
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-09-28-3d-kitchen-designer",
      function () {
        return require("private-next-pages/blogs/2025-09-28-3d-kitchen-designer/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-09-28-3d-kitchen-designer"])
      });
    }
  